
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import styles from './styles.module.scss';
import EditableText from "@/components/EditableText";
import EditableImage from "@/components/EditableImage";
import clsx from "classnames";
import PropTypes from "prop-types";
// import Marquee, { Motion, randomIntFromInterval } from "react-marquee-slider";
import Marquee from "react-fast-marquee";
import React, { useEffect, useState } from "react";

export default function MarqueeSlider({
    className,
    global,
    post,
    pathPrefix,
    content,
    imageSize,
    heading,
    content_html
}) {
    const [isSafari, setIsSafari] = useState(false);

    useEffect(() => {
        setIsSafari(/^((?!chrome|android).)*safari/i.test(navigator.userAgent));
    }, []);

    return (
        post?.length >= 1 && (
            <section className={clsx(className, styles.root)}>
                <Container>
                    <div className='wrapper'>
                        {heading && (
                            <EditableText
                                content={heading}
                                path={`${pathPrefix}.heading`}
                                global={global}
                                tag={`h2`}
                                className={`h3`}
                            />
                        )}
                        {content && (
                            <EditableText
                                content={content}
                                path={`${pathPrefix}.content`}
                                global={global}
                                tag={`div`}
                                className={`content`}
                                html={content_html}
                            />
                        )}
                    </div>
                </Container>
                <div className={`${content && ("mt-5")}`}>
                    <Marquee speed={12}>
                        {post?.map((post, index) => (
                            <div key={index} className='column'>
                                {isSafari ?
                                    <>
                                        <img
                                            size={`${imageSize}`}
                                            src={post?.logo ? post.logo : post?.image ? post.image : "/public/images/placeholders/img-placeholder.jpg"}
                                            alt={`${post.title}`}
                                        />
                                    </> :
                                    <>
                                        <EditableImage
                                            img={post?.logo ? post.logo : post?.image ? post.image : "/public/images/placeholders/img-placeholder.jpg"}
                                            size={`${imageSize}`}
                                            alt={`${post.title}`}
                                            height={`100%`}
                                        />
                                    </>}

                            </div>
                        ))}
                    </Marquee>
                </div>
            </section >
        )
    )
}
MarqueeSlider.defaultProps = {
    pathPrefix: "",
    className: "py-5",
    imageSize: "x225"
};

MarqueeSlider.propTypes = {
    pathPrefix: PropTypes.string,
    className: PropTypes.string,
    imageSize: PropTypes.string
};